import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "addPicture"
const AddPictureIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M18.75 13.125V17.25H22.875V18.75H18.75V22.875H17.25V18.75H13.125V17.25H17.25V13.125z" />
          <path d="M18 1.5C18.828 1.5 19.5 2.172 19.5 3V11.625H18V3H3V9.759C8.816 9.888 12.215 11.517 14.185 13.422 14.403 13.232 14.68 13.011 15.009 12.79Q15.342 12.564 15.75 12.35V14.1C15.523 14.258 15.33 14.414 15.174 14.55 15.397 14.851 15.586 15.151 15.75 15.442V15.75H14.184Q13.934 15.37 13.601 14.983C12.088 13.244 9.071 11.4 3 11.26V18H11.625V19.5H3C2.172 19.5 1.5 18.828 1.5 18V3C1.5 2.172 2.172 1.5 3 1.5z" />
          <path
            fillRule="evenodd"
            d="M13.875 4.5C15.325 4.5 16.5 5.675 16.5 7.125S15.325 9.75 13.875 9.75 11.25 8.575 11.25 7.125 12.425 4.5 13.875 4.5M13.875 6C13.254 6 12.75 6.504 12.75 7.125S13.254 8.25 13.875 8.25 15 7.746 15 7.125 14.496 6 13.875 6"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default AddPictureIcon
